import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirm-delete-peripheral',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-delete-peripheral.component.html',
  styleUrl: './confirm-delete-peripheral.component.scss'
})
export class ConfirmDeletePeripheralComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ConfirmDeletePeripheralComponent>
  ) {}

  onCancel() {
    this.dialogRef.close(false);
  }

  onConfirm() {
    this.dialogRef.close('delete');
  }
}

